var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 45,
    viewBox: "0 0 47 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.0471 21.5543V12.6392C26.0471 12.6392 22.2263 12.6392 19.2546 13.0637C16.2829 13.4882 9.06592 15.1863 9.06592 15.1863V21.5543H26.0471Z",
    fill: "#01A4A6",
    stroke: "#01A4A6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6132 24.9502H1C1 36.4125 12.4623 44.054 23.0755 44.054C34.1132 44.054 46 35.9879 46 24.9502H35.3868C31.9906 37.2615 13.3113 36.4125 11.6132 24.9502Z",
    fill: "#015373",
    stroke: "#015373"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0472 10.0919V1.17676C14.1604 4.23336 9.91509 6.69563 9.06604 7.54468V13.4881C14.5 11.4503 22.5094 10.3749 26.0472 10.0919Z",
    fill: "#01A4A6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.36792 16.0353V21.5541H1V17.3088C1.33962 16.29 5.24528 16.0353 7.36792 16.0353Z",
    fill: "#01A4A6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1698 10.0919V1.17676C30.8868 1.17676 32.9811 2.30883 33.6887 2.87487C33.8302 5.98808 33.6887 11.3654 33.6887 11.3654C33.6887 11.3654 29.8679 10.2334 28.1698 10.0919Z",
    fill: "#01A4A6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0566 4.99751C39.6321 4.57299 36.9434 3.72393 35.8113 3.72393V11.3654C37.5094 11.79 39.2076 12.2145 40.0566 12.639V4.99751Z",
    fill: "#01A4A6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M46 14.7617H41.7547V21.5541H46V14.7617Z",
    fill: "#01A4A6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6321 13.9126V21.5541H35.8113V13.9126H39.6321Z",
    fill: "#01A4A6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2642 13.4881C32.5849 13.1485 29.5849 12.7805 28.1698 12.639V21.5541H33.2642V13.4881Z",
    fill: "#01A4A6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0472 10.0919V1.17676C14.1604 4.23336 9.91509 6.69563 9.06604 7.54468V13.4881C14.5 11.4503 22.5094 10.3749 26.0472 10.0919Z",
    stroke: "#01A7A7"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M7.36792 16.0353V21.5541H1V17.3088C1.33962 16.29 5.24528 16.0353 7.36792 16.0353Z",
    stroke: "#01A7A7"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1698 10.0919V1.17676C30.8868 1.17676 32.9811 2.30883 33.6887 2.87487C33.8302 5.98808 33.6887 11.3654 33.6887 11.3654C33.6887 11.3654 29.8679 10.2334 28.1698 10.0919Z",
    stroke: "#01A7A7"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0566 4.99751C39.6321 4.57299 36.9434 3.72393 35.8113 3.72393V11.3654C37.5094 11.79 39.2076 12.2145 40.0566 12.639V4.99751Z",
    stroke: "#01A7A7"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M46 14.7617H41.7547V21.5541H46V14.7617Z",
    stroke: "#01A7A7"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6321 13.9126V21.5541H35.8113V13.9126H39.6321Z",
    stroke: "#01A7A7"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2642 13.4881C32.5849 13.1485 29.5849 12.7805 28.1698 12.639V21.5541H33.2642V13.4881Z",
    stroke: "#01A7A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.9db5598af1f8af07eb8bce1382278267.svg";
export { ForwardRef as ReactComponent };